import { axios } from "utils";

import { ADMIN_USERS_URL as endpoint } from "consts";

import { CacheInvalidation } from "models";

export const getAllUsers = async (data: unknown) => axios.get(`${endpoint}`, { data });

export const getFullUserDetails = async (data: { id: string }) => axios.get(`${endpoint}/${data.id}`, { data });

export const toggleUser = async (data: unknown) => axios.post(`${endpoint}/toggle`, { data });

export const getAllEmails = async (data: unknown) => axios.get(`${endpoint}/emails`, { data });

export const getUserFarms = async (data: { userId: string }) => axios.get(`${endpoint}/${data.userId}/farms`, { data });

export const getUserCacheInvalidationAdmin = async (data: { userId: string }): Promise<CacheInvalidation> =>
  axios.get(`${endpoint}/${data.userId}/cache-invalidation`);
